<div class="btn-up">
  <button mat-fab color="accent" (click)="scrollToTop()">
    <mat-icon>arrow_upward</mat-icon>
  </button>
</div>
